$(function () {
    $('.hindle-post-type-list').uniformify({
        selector: '.item h3'
    });
});
